import { useTranslation } from 'react-i18next';
import { E2NTableCell } from '../../../../components/Table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { antragsZeit, Pause } from '../../entities';
import { faPaperPlane } from '@fortawesome/pro-light-svg-icons';
import { Link, useParams } from 'react-router-dom';
import { ArbeitszeitArbeitszeitantragStatus } from '@/gql/graphql';
import dayjs from 'dayjs';
import { Ende } from './ArbeitszeitCell';
import { PausenHoverCard } from '@/domain/arbeitszeiten/components/PausenHoverCard';

function AntragWrapper({
  status,
  time,
}: {
  status?: ArbeitszeitArbeitszeitantragStatus;
  time: string;
}) {
  const bgColor =
    status === ArbeitszeitArbeitszeitantragStatus.Genehmigt
      ? 'bg-primary-green-100'
      : status === ArbeitszeitArbeitszeitantragStatus.Abgelehnt
        ? 'bg-primary-red-100'
        : 'bg-primary-blue-100';

  const textColor =
    status === ArbeitszeitArbeitszeitantragStatus.Genehmigt
      ? 'text-primary-green-600'
      : status === ArbeitszeitArbeitszeitantragStatus.Abgelehnt
        ? 'text-primary-red-400'
        : 'text-primary-blue-600';

  return (
    <div className={`flex items-center gap-2 ${bgColor} p-1 rounded-md w-fit`}>
      <span className={`${textColor}`}>{time}</span>
      <FontAwesomeIcon
        size="xs"
        className={`${textColor}`}
        icon={faPaperPlane}
      />
    </div>
  );
}

// oxlint-disable-next-line complexity
export const ArbeitszeitAntragCell = function ArbeitszeitAntragCell({
  beginn,
  ende,
  dauer,
  pausen,
  status,
  antragId,
  arbeitszeitId,
}: {
  beginn?: antragsZeit;
  ende?: antragsZeit;
  dauer?: number;
  pausen: Pause[];
  status?: ArbeitszeitArbeitszeitantragStatus;
  antragId: string;
  arbeitszeitId?: string;
}) {
  const { t } = useTranslation();
  const { year, month, day } = useParams();

  const linkToAntrag =
    status === ArbeitszeitArbeitszeitantragStatus.Genehmigt
      ? `/arbeitszeiten/uebersicht/${year}/${month}/${day}/sheet/edit/${arbeitszeitId}/antraege`
      : `/arbeitszeiten/uebersicht/${year}/${month}/${day}/sheet/antrag/${antragId}`;

  return (
    <E2NTableCell className="font-semibold w-[30%]" isBorderVisible>
      <div className="flex items-center justify-between gap-4">
        <div className="flex flex-col gap-1 items-start basis-[70px]">
          {beginn?.isChangeRequested ? (
            <Link to={linkToAntrag}>
              <AntragWrapper
                status={status}
                time={dayjs(beginn.time).format('HH:mm')}
              />
            </Link>
          ) : (
            <span>
              {beginn?.time ? dayjs(beginn.time).format('HH:mm') : '--:--'}
            </span>
          )}
        </div>
        {dauer !== 0 ? (
          <>
            <div className="h-px bg-neutrals-500 grow" />
            <PausenHoverCard pausen={pausen}>
              <span className="text-xs text-neutrals-700">
                {dauer} {t('general.date.minutes')}
              </span>
            </PausenHoverCard>
            <div className="h-px bg-neutrals-500 grow" />
          </>
        ) : (
          <div className="h-px bg-neutrals-500 grow" />
        )}

        <div className="flex flex-col gap-1 basis-[100px]">
          {ende?.isChangeRequested ? (
            <Link to={linkToAntrag}>
              <AntragWrapper
                status={status}
                time={dayjs(ende.time).format('HH:mm')}
              />
            </Link>
          ) : (
            <span>
              {ende?.time ? (
                dayjs(ende.time).format('HH:mm')
              ) : (
                <Ende datum={ende?.time} />
              )}
            </span>
          )}
        </div>
      </div>
    </E2NTableCell>
  );
};
